import { channelNumberDuplicate } from './rules/channel-number-duplicate.js';
import { channelWithoutSource } from './rules/channel-without-source.js';
import { circuitOverload } from './rules/circuit-overload.js';
import { condenserWithoutPhantom } from './rules/condenser-without-phantom.js';
import { connectionDangling } from './rules/connection-dangling.js';
import { connectorMismatch } from './rules/connector-mismatch.js';
import { dmxConflict } from './rules/dmx-conflict.js';
import { inputDoubleBooked } from './rules/input-double-booked.js';
import { itemUnplaced } from './rules/item-unplaced.js';
import { micWithoutChannel } from './rules/mic-without-channel.js';
import { mixWithoutOutput } from './rules/mix-without-output.js';
import { mountInvalid } from './rules/mount-invalid.js';
import { parentInvalid } from './rules/parent-invalid.js';
import { patchDoubleBooked } from './rules/patch-double-booked.js';
import { rfConflict } from './rules/rf-conflict.js';
import { outputToOutput } from './rules/output-to-output.js';
import { signalTypeMismatch } from './rules/signal-type-mismatch.js';
import { voltageMismatch } from './rules/voltage-mismatch.js';
import type { Rule } from './types.js';

/** All validation rules (architecture §3), errors first. */
export const RULES: readonly Rule[] = [
  outputToOutput,
  inputDoubleBooked,
  channelNumberDuplicate,
  dmxConflict,
  voltageMismatch,
  connectionDangling,
  mountInvalid,
  parentInvalid,
  condenserWithoutPhantom,
  patchDoubleBooked,
  connectorMismatch,
  mixWithoutOutput,
  circuitOverload,
  signalTypeMismatch,
  rfConflict,
  micWithoutChannel,
  channelWithoutSource,
  itemUnplaced,
];

/** Rule metadata by id. */
export function getRule(id: string): Rule | undefined {
  return RULES.find((r) => r.id === id);
}
